import React from 'react';
import classes from './Statistic.module.css';

const PatientsStatistic = (props) => {
  return (
    <div className={classes.Stat}>
      <h1>PatientsStatistic</h1>
      <div>
        <p>
          Select "Logout" below if you are ready to end your current session.
        </p>
      </div>
      Select "Logout" below if you are ready to end your current session.
      <div>
        <button
          className="btn btn-secondary"
          type="button"
          data-dismiss="modal"
        >
          Cancel
        </button>
        <a className="btn btn-primary" href="login.html">
          Logout
        </a>
      </div>
    </div>
  );
};
export default PatientsStatistic;
